"use strict";
var _ = require("lodash");

module.exports = /* @ngInject */ function(
  rediVersionCheck,
  menuItemRepository
) {
  var that = this;
  var REDI_MINIMUM_VERSION_FOR_EIKON_LIGHT = "17.2.0.036";
  var REDI_MINIMUM_VERSION_FOR_ESO_PROMPT = "22.1.0.012";

  var isUsingEikonLightPromise;

  that.isUsingEikonLight = function() {
    if (!isUsingEikonLightPromise) {
      isUsingEikonLightPromise = checkEikonLightUsage();
    }
    return isUsingEikonLightPromise;
  };

  that.canHaveEikonSession = hasEikonMenuItems;

  that.maybePromptUserToRelogin = function() {
    return rediVersionCheck
      .isExpectingVersionFromRedi()
      .then(function(isExpecting) {
        return (
          isExpecting &&
          rediVersionCheck.isGreaterThanOrEqualTo(
            REDI_MINIMUM_VERSION_FOR_ESO_PROMPT
          )
        );
      });
  };

  function hasEikonMenuItems() {
    return menuItemRepository.get().then(function(menuItems) {
      var numberOfEikonMenuItems = _.filter(menuItems, { platform: "Eikon" })
        .length;
      return numberOfEikonMenuItems > 0;
    });
  }

  function checkEikonLightUsage() {
    return rediVersionCheck
      .isExpectingVersionFromRedi()
      .then(function(expectingVersionFromRedi) {
        if (!expectingVersionFromRedi) {
          return false;
        }
        return checkMenuItemsAndVersion();
      });
  }

  function checkMenuItemsAndVersion() {
    return hasEikonMenuItems().then(function(hasEikonMenuItems) {
      return (
        rediVersionCheck.isGreaterThanOrEqualTo(
          REDI_MINIMUM_VERSION_FOR_EIKON_LIGHT
        ) && hasEikonMenuItems
      );
    });
  }
};



// WEBPACK FOOTER //
// ./app/infrastructure/eikonUsageCheck.js